import React from 'react'
import { FormattedMessage } from 'react-intl'

export const networkError = {
  general_errors: [<FormattedMessage id="form.errors.notAbleToConnect" />],
}

export const fallbackSubmitSuccessMessage = (
  <FormattedMessage id="form.success.defaultMessage" />
)

export const noSlugWarning = <FormattedMessage id="form.errors.noSlugWarning" />

export const errorHintMessage = <FormattedMessage id="form.errors.badInput" />

export const expiredFormError = <FormattedMessage id="form.errors.isExpired" />
export const expiredFormErrorDesc = (
  <FormattedMessage id="form.errors.isExpiredDesc" />
)

export const deActivatedFormError = (
  <FormattedMessage id="form.errors.deactivated" />
)

export const deActivatedFormErrorDesc = (
  <FormattedMessage id="form.errors.notAvailableToSubmitDeactivatedOrAccessDenied" />
)
